"use strict";

import request from "@/utils/request";
const config = require("../../config/config.json");

export async function svc_fetchProductCatalog(params) {
	const query = new URLSearchParams();
	if (params) {
		Object.keys(params).forEach((key) => {
			if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
				query.append(key, params[key]);
			}
		});
	}
	return request(`${config.apiUrl}product_catalog?${query.toString()}`, {
		method: "GET",
	});
}

export async function svc_fetchCatalogItem(id) {
	return request(`${config.apiUrl}product_catalog/${id}`, {
		method: "GET",
	});
}

export async function svc_createCatalogItem(data) {
	return request(`${config.apiUrl}product_catalog`, {
		method: "POST",
		data,
	});
}

export async function svc_updateCatalogItem(id, data) {
	return request(`${config.apiUrl}product_catalog/${id}`, {
		method: "PUT",
		data,
	});
}

export async function svc_deleteCatalogItem(id) {
	return request(`${config.apiUrl}product_catalog/${id}`, {
		method: "DELETE",
	});
}

export async function svc_bindCatalogItem(data) {
	return request(`${config.apiUrl}product_catalog/bind`, {
		method: "POST",
		data,
	});
}

export async function svc_unbindCatalogItem(data) {
	return request(`${config.apiUrl}product_catalog/unbind`, {
		method: "POST",
		data,
	});
}
